module.exports = __webpack_public_path__ + "img/charging-hub-in-progress-private.f1aabbef.png";